import { FormBase } from 'core/components';

export default class UpdateBuyShippingForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'useBuyShipping',
					label: 'UPDATEBUYSHIPPINGVIEW.USEBUYSHIPPING',
					value: true,
					type: 'checkbox',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/UpdateBuyShippingForm.js